import type { CSSProperties } from "react";
import type { Technician } from "@shared/modules/x-atelier";

interface TechChipsProps {
  technicians: Technician[];
  value: string;
  onChange: (technicianId: string) => void;
}

/**
 * Filtre par technicien en pastilles tactiles (« Tous », puis chacun avec sa
 * couleur d'agenda) : plus rapide qu'un menu déroulant sur une tablette et
 * la légende des couleurs devient inutile — elle est là.
 */
export function TechChips({ technicians, value, onChange }: TechChipsProps) {
  const active = technicians.filter((t) => t.active);
  if (active.length === 0) return null;
  return (
    <div className="chips" role="group" aria-label="Technicien">
      <button
        type="button"
        className={`chips__chip${value === "" ? " is-active" : ""}`}
        aria-pressed={value === ""}
        onClick={() => onChange("")}
      >
        Tous
      </button>
      {active.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`chips__chip chips__chip--tech${value === t.id ? " is-active" : ""}`}
          style={{ "--tech-color": t.color } as CSSProperties}
          aria-pressed={value === t.id}
          onClick={() => onChange(value === t.id ? "" : t.id)}
        >
          <span className="chips__dot" aria-hidden="true" />
          {t.displayName}
        </button>
      ))}
    </div>
  );
}
